<template>
    <!-- <nav>
        <router-link to="/"></router-link>
    </nav> -->
    <router-view />
</template>

<style lang="scss">
* {
    margin: 0;
    padding: 0;
}
</style>
